import { combineReducers } from '@reduxjs/toolkit';
import { reducer as user } from './user';

export const reducers = combineReducers({
    user,
});
